import {
  AdminPanelSettings,
  Apps,
  BusinessCenter,
  DynamicForm,
  Input,
  Delete,
  AccountBalance as AccountBalanceIcon,
} from '@mui/icons-material';

import { Routes } from '../constants';
import { INavLink, INavLinkHeader, IRoleType } from '../models';

const accountingLinks: INavLink[] = [
  {
    name: 'NetSuite Log',
    route: Routes.netSuiteLog,
    roles: [IRoleType.Accounting, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
];

const adminLinks: INavLink[] = [
  {
    name: 'Activity Types',
    route: Routes.activityTypes,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Bank Accounts',
    route: Routes.bankAccounts,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Commission Tables',
    route: Routes.commissionTables,
    roles: [IRoleType.SystemAdmin, IRoleType.Accounting],
    requiredFeatureFlags: [],
  },
  {
    name: 'Employees',
    route: Routes.employees,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: ['modern-employee-admin'],
  },
  {
    name: 'Employee Specialty Types',
    route: Routes.employeeSpecialtyTypes,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Events',
    route: Routes.events,
    roles: [IRoleType.SystemAdmin, IRoleType.Marketing],
    requiredFeatureFlags: ['events'],
  },
  {
    name: 'File Use Types',
    route: Routes.fileUseTypes,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Line of Business',
    route: Routes.lineOfBusiness,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Listing Interaction Types',
    route: Routes.listingInteractionTypes,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Margin Categories',
    route: Routes.marginCategory,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Netsuite Account IDs',
    route: Routes.netSuiteConfig,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Property Types',
    route: Routes.propertyTypes,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Property Subtypes',
    route: Routes.propertySubTypes,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Support Team Roles',
    route: Routes.supportTeam,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Client Segementation',
    route: Routes.clientSegmentation,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Occupier Service Categories',
    route: Routes.occupierServices,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Represented By',
    route: Routes.representedBy,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'SMP Bundles',
    route: Routes.smpbundles,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },

];

const importLinks: INavLink[] = [
  {
    name: 'People',
    route: Routes.peopleImport,
    roles: [IRoleType.ImportUser, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Properties',
    route: Routes.propertiesImport,
    roles: [IRoleType.ImportUser, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Companies',
    route: Routes.companiesImport,
    roles: [IRoleType.ImportUser, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Unit Mixes',
    route: Routes.unitMixesImport,
    roles: [IRoleType.ImportUser, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Legacy Investment Sales Activities',
    route: Routes.investmentSalesImport,
    roles: [IRoleType.ImportUser, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Active Investment Sales Activities',
    route: Routes.activeInvestmentSalesImport,
    roles: [IRoleType.ImportUser, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
  {
    name: 'Listing Stats',
    route: Routes.listingStatsImport,
    roles: [IRoleType.ImportUser, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
];

const dynamicFields: INavLink[] = [
  {
    name: 'Dynamic Fields',
    route: Routes.dynamicFields,
    roles: [IRoleType.DynamicFields, IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
];

const smpLinks: INavLink[] = [
  {
    name: 'SMP',
    route: Routes.smp,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
];

const softDeletes: INavLink[] = [
  {
    name: 'Soft Deletes',
    route: Routes.softDeletes,
    roles: [IRoleType.SystemAdmin],
    requiredFeatureFlags: [],
  },
];

const drawsAndDeductions: INavLink[] = [
  {
    name: 'Draws & Deductions',
    route: Routes.drawsAndDeductions,
    roles: [IRoleType.SystemAdmin, IRoleType.Accounting],
    requiredFeatureFlags: ['draws-and-deductions'],
  },
];

export const navLinkHeaders: INavLinkHeader[] = [
  {
    name: 'Draws & Deductions',
    icon: <AccountBalanceIcon fontSize="small" />,
    links: drawsAndDeductions,
  },
  {
    name: 'Soft Deletes',
    icon: <Delete fontSize="small" />,
    links: softDeletes,
  },
  {
    name: 'SMP',
    icon: <Apps fontSize="small" />,
    links: smpLinks,
  },
  {
    name: 'Accounting',
    icon: <BusinessCenter fontSize="small" />,
    links: accountingLinks,
  },
  {
    name: 'Admin',
    icon: <AdminPanelSettings fontSize="small" />,
    links: adminLinks,
  },
  {
    name: 'Dynamic Fields',
    icon: <DynamicForm fontSize="small" />,
    links: dynamicFields,
  },
  {
    name: 'Import',
    icon: <Input fontSize="small" />,
    links: importLinks,
  },
];
